import script from "./SwitchConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./SwitchConfirmDialog.vue?vue&type=style&index=0&id=012fbef8&lang=scss"

const __exports__ = script;

export default __exports__